import { coreTranslations } from 'translations';
import featureService from '@services/feature.service';
import isMobileAppView from 'common/utility/isMobileAppView';
import PermissionService from '@services/permission.service';

const { canViewOpV3, canManageAssetDataStore, canManageRiskIntelligenceDivisionSync } = new PermissionService().permissions
const canManageOPV3 = canViewOpV3() && canManageAssetDataStore();

const canViewOPDivisionsManagement = canManageRiskIntelligenceDivisionSync() || canManageOPV3;

export const permissionsConfig = [
    {
        id: 'roles',
        title: canManageOPV3 ? coreTranslations.ng_core_roles_and_templates : coreTranslations.ng_core_roles,
        description: canManageOPV3
            ? coreTranslations.ng_core_rolesAndTemplatesDescription
            : coreTranslations.ng_core_rolesDescription,
        path: canManageOPV3
            ? '/roles'
            : {
                  redirectTo: '/res/security/show-roles.html',
                  redirectBaseUrl: 'MIR3ApiBaseUrl'
              },
        visible: access =>
            canManageOPV3
                ? access.canViewRoles()
                : access.canViewRoles() && featureService.getFeature('mir3Redirects') && !isMobileAppView()
    },
    //TODO: Remove Add Role item when new roles management is implemented in OnSolve (ON-5507).
    {
        id: 'add-role',
        title: coreTranslations.ng_core_addRole,
        description: coreTranslations.ng_core_addRoleDescription,
        path: {
            redirectTo: '/res/security/edit-role.html',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access =>
            access.canEditRoles() &&
            (featureService.getFeature('mir3Redirects') && !isMobileAppView()) &&
            !canManageOPV3
    },
    //TODO: Remove Add Role Template item when new roles management is implemented in OnSolve (ON-5507).
    {
        id: 'add-role-template',
        title: coreTranslations.ng_core_addRoleTemplate,
        description: coreTranslations.ng_core_addRoleTemplateDescription,
        path: {
            redirectTo: '/prepareEditRoleTemplate.do',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access =>
            access.canEditRoles() &&
            (featureService.getFeature('mir3Redirects') && !isMobileAppView()) &&
            !canManageOPV3
    },
    {
        id: 'divisions',
        title: coreTranslations.ng_core_divisions,
        description: coreTranslations.ng_core_divisionsDescription,
        path: canViewOPDivisionsManagement
            ? '/divisions'
            : {
                  redirectTo: '/res/organization/manage-divisions.html',
                  redirectBaseUrl: 'MIR3ApiBaseUrl'
              },
        visible: access =>
            canViewOPDivisionsManagement
                ? access.canViewDataHierarchy()
                : access.canViewDataHierarchy() && (featureService.getFeature('mir3Redirects') && !isMobileAppView())
    },
    {
        id: 'smime',
        title: coreTranslations.ng_core_smime,
        description: coreTranslations.ng_core_smimeDescription,
        path: {
            redirectTo: '/res/organization/smime.html',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access =>
            access.canViewManageDivisionSMIMEKeys() &&
            (featureService.getFeature('mir3Redirects') && !isMobileAppView())
    },
    {
        id: 'moveDivisions',
        title: coreTranslations.ng_core_moveDivisions,
        description: coreTranslations.ng_core_moveDivisionsDescription,
        path: {
            redirectTo: '/prepareManageDivisions.do',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access =>
            !canViewOPDivisionsManagement &&
            !access.usesNextGenSendingEngine() &&
            !access.canManageRiskIntelligenceDivisionSync() &&
            access.canViewMoveDivisions() &&
            (featureService.getFeature('mir3Redirects') && !isMobileAppView())
    },
    {
        id: 'divisionBoundaries',
        title: coreTranslations.ng_core_divisionBoundaries,
        description: coreTranslations.ng_core_divisionBoundariesDescription,
        path: {
            redirectTo: '/res/organization/manage-division-boundary.html',
            redirectBaseUrl: 'MIR3ApiBaseUrl'
        },
        visible: access =>
            access.canViewDivisionBoundaries() && (featureService.getFeature('mir3Redirects') && !isMobileAppView())
    }
];
